<template>
  <NuxtLinkWithLocale
      :to="props.productLink"
      :id="props.id || 'brand-product-card-' + randomId"
      :data-testid="props.dataTestid ? props.dataTestid + '_brand-product-link' : '_brand-product-link'"
      :class="
      $attrs.class ||
      twMerge(
        'relative flex flex-col justify-center h-full w-full pt-0.5 pb-2 px-2 cursor-pointer rounded-xl',
        !props.productImage && 'p-3.5',
        props.appendClass
      )
    "
    :style="{'background-color': props.backgroundColor}"
  >
    <slot name="media">
      <TsImage v-if="props.productImage"
               :src="`${props.productImage}?format=webp`"
               :alt="props.productImageAlt || 'product'"
               loading="lazy"
               width="144"
               height="134"
               class="max-w-full h-auto mx-auto"
      />
    </slot>
    <slot name="footer">
      <TsImage
          :src="`${props.productImageBrand}?format=webp`"
          :alt="props.productImageAlt || 'brand'"
          loading="lazy"
          width="144"
          height="41"
          class="object-cover mx-auto  min-w-[105px] max-h-[37px]"
      />
    </slot>
  </NuxtLinkWithLocale>
</template>

<script setup lang="ts">
import {twMerge} from "tailwind-merge";
import {ref, onMounted} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";

type Props = {
  id?: string;
  cardText?: string;
  productImage?: string;
  productImageBrand?: string;
  productImagealt?: string | number;
  productLink?: string;
  appendClass?: string;
  dataTestid?: string;
  backgroundColor?: string;

};

const props = withDefaults(defineProps<Props>(), {
  cardText: "",
  productImageAlt: "dewalt cordless brushless circular saw body",
  productLink: "#",
  appendClass: "",
});

const randomId = ref("");

onMounted(() => {
  randomId.value = useRandomUUID();
});
</script>
